module.exports = __webpack_public_path__ + "img/fb.cfb43824.png";